import React, { Fragment, useContext, useEffect, useState } from "react";
import { APIContext } from "../../Contexts/APIContext";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import AgentFeedbackPage from "./AgentFeedbackPage";
import FeedbackTable from "../Shared/FeedbackTable";
import FeedbackRowViewModel from "../ViewModels/FeedbackRowViewModel";
import FilterChip from "../../Filtering/FilterChip";
import AgentQaiChallengeFeedback from "./AgentQaiChallengeFeedback";

interface IProps {
    setFeedback?: (count: number) => void;
}

export default function AgentFeedbackContainer(props: IProps) {
    const { get } = useContext(APIContext);
    const [feedbackRows, setFeedbackRows] = useState<FeedbackRowViewModel[]>([]);
    const [callRefId, setCallRefId] = useState<string | null>(null);
    const [systemId, setSystemId] = useState<string | null>(null);
    const [completeId, setCompleteId] = useState<number | null>(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [count, setCount] = useState(0);
    const [agentName, setAgentName] = useState("");
    const [client, setClient] = useState("");
    const [minDate, setMinDate] = useState("");
    const [qaiChallengesFeedbackOpen, setQaiChallengesFeedbackOpen] = useState(false);

    useEffect(() => {
        getAgentData();
    }, []);

    useEffect(() => {
        getFeedbackData();
    }, [page, rowsPerPage]);

    const getFeedbackData = () => {
        get('Feedback', `GetAgentsFeedback?page=${page}&rowsPerPage=${rowsPerPage}`, (data) => {
            setFeedbackRows(data.callrows);
            setCount(data.callrows.length);
            getFeedbackCount();
        });
    }

    const getAgentData = () => {
        get('Feedback', `GetAgentData`, (data) => {
            setAgentName(data.name);
            setClient(data.client);
            setMinDate(data.date);
        });
    }

    const getFeedbackCount = () => {
        if (props.setFeedback) {
            get('Feedback', `GetAgentsFeedbackCount`, (data) => {
                props.setFeedback!(data)
            });
        }
    }

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    }

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    }

    const handleFeedbackOpen = (callRefId: string, completeId: number, systemId: string) => {
        setCallRefId(callRefId);
        setCompleteId(completeId);
        setSystemId(systemId)
    }

    const handleFeedbackClose = () => {
        setCompleteId(null)
        getFeedbackData();
    }

    const handleQaiChallengesFeedbackOpen = () => {
        setQaiChallengesFeedbackOpen(true);
    }

    const handleQaiChallengesFeedbackClose = () => {
        setQaiChallengesFeedbackOpen(false);
    }

    return (
        <Fragment>
            <Dialog
                open={callRefId !== null && completeId !== null}
                onClose={handleFeedbackClose}
                fullScreen
            >
                {callRefId !== null && completeId !== null && systemId !== null &&
                    <AgentFeedbackPage
                        callRefId={callRefId}
                        completeId={completeId}
                        close={handleFeedbackClose}
                        agentView={true}
                        systemId={systemId}
                    />
                }
            </Dialog>
            <AgentQaiChallengeFeedback open={qaiChallengesFeedbackOpen} close={handleQaiChallengesFeedbackClose} />
            <Grid container spacing={1} paddingTop={1}>
                <Grid size={12}>
                    <Grid container padding={1} justifyContent='space-between' size={12}>
                        <Grid container size={6} spacing={1}>
                            <FilterChip
                                filterLabel={client}
                                filterFlag={''}
                                filterNames={['']}
                                filterComponent={<Fragment />}
                                showFilter />
                            <FilterChip
                                filterLabel={"Date from: " + minDate}
                                filterFlag={''}
                                filterNames={['']}
                                filterComponent={<Fragment />}
                                showFilter />
                            <FilterChip
                                filterLabel={"Agent Name: " + agentName}
                                filterFlag={''}
                                filterNames={['']}
                                filterComponent={<Fragment />}
                                showFilter />
                        </Grid>
                        <Grid container size={3} spacing={1} justifyContent='flex-end'>
                            <Grid>
                                <Button variant='contained' onClick={handleQaiChallengesFeedbackOpen}>View Q-AI Challenges</Button>
                            </Grid>
                            <Grid>
                                <Button
                                    fullWidth
                                    variant='contained'
                                    color='secondary'
                                    onClick={() => getFeedbackData()}
                                >
                                    Refresh
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={12}>
                    <FeedbackTable
                        view="Agent"
                        feedbackRows={feedbackRows}
                        handleFeedbackOpen={handleFeedbackOpen}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                        page={page}
                        count={count}
                        rowsPerPage={rowsPerPage}
                    />
                </Grid>
            </Grid>
        </Fragment >
    );
}